import { __decorate } from "tslib";
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { Size } from './enums/size.js';
import './viedoc-wordmark.js';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { Large, ...FooterSize } = Size;
export { FooterSize };
let ViedocFooter = class ViedocFooter extends LitElement {
    constructor() {
        super(...arguments);
        this.copyright = '';
        this.hiddenLogo = false;
        this.size = FooterSize.Medium;
        this.timestamp = '';
        this.version = '';
    }
    render() {
        const classNames = classMap({
            footer: true,
            [`footer--${this.size}`]: true,
        });
        const footerList = (items) => {
            const footerItems = items
                .filter((item) => item.length)
                .map((item) => html `<div class="footer__item">${item}</div>`);
            return footerItems.length
                ? html `<div class="footer__list">${footerItems}</div>`
                : nothing;
        };
        return html `
      <footer class=${classNames}>
        ${this.hiddenLogo ? nothing : html `<viedoc-wordmark></viedoc-wordmark>`}
        <div class="footer__content">
          <div class="footer__row">
            ${footerList([this.copyright])}
            <div class="footer__links">
              <slot name="links"></slot>
            </div>
          </div>
          ${footerList([this.version, this.timestamp])}
          <div class="footer__additional">
            <slot name="additional"></slot>
          </div>
        </div>
      </footer>
    `;
    }
};
ViedocFooter.styles = [
    css `
      :host {
        align-items: center;
        text-align: center;
      }

      .footer {
        font-family: var(--font-family-monument);
        font-weight: 400;
        display: flex;
        flex-direction: column;
        align-items: inherit;
        text-align: inherit;
        gap: 0.375rem; /* 6px */
      }

      .footer__content {
        display: flex;
        flex-direction: column;
        align-items: inherit;
        text-align: inherit;
        font-size: var(--font-size-2xs);
        line-height: var(--line-height-looser);
        font-weight: 400;
      }

      .footer__row,
      .footer__list,
      .footer__links {
        display: flex;
        flex-direction: row;
        align-items: inherit;
        text-align: inherit;
      }

      .footer__list {
        color: var(--color-gray-60);
      }

      .footer__item,
      .footer__links ::slotted(*) {
        display: flex;
      }

      .footer__item:not(:first-child)::before,
      .footer__links ::slotted(*)::before {
        content: '•';
        display: flex;
        align-self: center;
        justify-content: center;
        width: calc(0.625rem * 2);
        color: var(--color-gray-60);
      }

      .footer__additional ::slotted(*) {
        display: block;
        margin-top: 1rem;
      }

      /* -- FOOTER SIZES -- */

      .footer--small .footer__content {
        font-size: var(--font-size-2xs);
      }

      .footer--small .footer__links {
        display: none;
      }

      .footer--small .footer__list {
        flex-direction: column;
      }

      .footer--small .footer__list .footer__item::before {
        content: none;
      }

      @media (max-width: 64rem) {
        .footer__row {
          flex-direction: column;
        }

        .footer__links ::slotted(*:first-child)::before {
          content: none;
        }
      }

      @media (max-width: 30rem) {
        .footer__list {
          flex-direction: column;
        }

        .footer__list .footer__item::before {
          content: none;
        }
      }
    `,
];
__decorate([
    property({ type: String })
], ViedocFooter.prototype, "copyright", void 0);
__decorate([
    property({ type: Boolean, attribute: 'hidden-logo', reflect: true })
], ViedocFooter.prototype, "hiddenLogo", void 0);
__decorate([
    property({ type: String })
], ViedocFooter.prototype, "size", void 0);
__decorate([
    property({ type: String })
], ViedocFooter.prototype, "timestamp", void 0);
__decorate([
    property({ type: String })
], ViedocFooter.prototype, "version", void 0);
ViedocFooter = __decorate([
    customElement('viedoc-footer')
], ViedocFooter);
export { ViedocFooter };
